import './master.css';
import './header.css';
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // For React Router v6
import india from "../../assets/images/indianflag.gif";
import logo from "../../assets/images/smartLogoMain.png";
import { logout } from '../../services/auth.service';

const HeaderComponent = () => {
  const [showMainHeader, setShowMainHeader] = useState(true);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768); //initiate  screen check
  const navigate = useNavigate(); 
  const location = useLocation(); 

  const isLoggedIn = localStorage.getItem("user");
  const excludedPages = ['/','/aboutus','/executive-council','/committee-member','/active-members','/register','/login','/forgot-password',
        '/contact','/sponsorship','/sponsor','/smart-venue','/gallery']; // List of pages to exclude
  const isOnExcludedPage = excludedPages.includes(location.pathname);

  /******* Logout Function ********/
  const handleLogout = (e) => {
    e.preventDefault();
    logout("L");
    navigate("/"); // Redirect to login
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    navigate("/change-password");
  };

  const handleDashboard = (e) => {
    e.preventDefault();
    navigate("/dashboard"); 
  };
  


  useEffect(() => {
    // Listener for scroll event
    const handleScroll = () => {
      if (isMobileView) {
        const nav = document.getElementById("fixed-sub-nav");
        if (nav) {
          const position = nav.getBoundingClientRect().top;
          setShowMainHeader(position > 0);
        }
      }
    };

    const handleResize = () => {
      const isNowMobile = window.innerWidth <= 768;
      setIsMobileView(isNowMobile);
    };

  

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial 

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobileView]);

  return (
    <>
      {showMainHeader && (
        <header className="header-nav shadow-sm">
          <div className="header-container col-md-12">
            {isMobileView ? (
               <div className="mobile-view-header">
                <div className="mobile-logo-title">
                  <img src={india} alt="india" className="mobile-india-logo" />
                  <img src={logo} alt="logo" className="mobile-smart-logo" />
                  <p className="mobile-title">
                     Society for Microwaves, Antennas and Radar Technologies
                 </p>
               </div>
            </div>
      ) : (
        <div className="desktop-view-header d-flex align-items-center">
          <div className="logo-container">
             <img src={india} alt="india" className="india-image" />
             <img src={logo} alt="logo" className="logo-image" />
          </div>
          <div className="title-container">
              <p className="title-text">Society for Microwaves, Antennas and Radar Technologies</p>
         </div>

         {isLoggedIn && !isOnExcludedPage && (
                  <div className="title-container">
                    <span className="logoutText" onClick={handleDashboard}>Dashboard</span>
                    <span className="logoutText">&nbsp;|&nbsp;</span>
                    <span className="logoutText" onClick={handleChangePassword}>Change Password</span>
                    <span className="logoutText">&nbsp;|&nbsp;</span>
                    <span className="logoutText" onClick={handleLogout}>Log Out</span>
                  </div>
                )}
          </div>
         )}
        </div>
        <div className="nav-bar-container col-md-12">{/* header */}</div>
      </header>
      )}

      
     {isMobileView && isLoggedIn && !isOnExcludedPage && (
        <nav className="custom-mobile-nav">
          <ul className="custom-mobile-menu">
            <li onClick={handleDashboard} className="custom-mobile-item"><span>Dashboard</span></li>
            <li onClick={handleChangePassword} className="custom-mobile-item"><span>Change Password</span></li>
            <li onClick={handleLogout} className="custom-mobile-item"><span>Log Out</span></li>
          </ul>
        </nav>
      )}

      {/* {isMobileView && !showMainHeader && (
        <div className="minimal-header">
          <p>SMART</p>
        </div>
      )} */}
    </>
  );
};

export default HeaderComponent;